import { Period } from "../../atoms/hours/Period"

export const FormHorario = ({ title, regularHour }) => {


    return (
        <div style={{ display: "flex", justifyContent:'space-between', width:'100%', margin:'10px' }}>

            <small style={{ textAlign:'start'}} >
                {title}
            </small>
            <div>
                {
                    regularHour.length === 0
                        ? 
                            <small style={{color:'grey'}}>Cerrado</small>
                        : 
                            regularHour.map((data, i) => (
                                <Period data={data} key={i} />
                            ))
                }
            </div>
        </div>

    )
}
